export default __webpack_public_path__ + "static/media/logo-hauts.c985a12a.png";